import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import React , { Fragment } from 'react';
import {useRouter} from 'next/router'
import Tabs from '../../components/common/Tabs/Tabs';
import dynamic from "next/dynamic";
import {trackPage} from "../../tracking/index";
import Config from '../../config';
import {getStaticPath} from '../../utils';
import { getPageViewData } from '../../utils/tracking';

const PrivacyPolicy = dynamic(()=> import('../../components/privacy-policy/index'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

export async function getServerSideProps() {
  return {
    props: {
      pageName: 'privacy-policy'
    }

  }
}

export default function Home() {
  const router = useRouter()
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath("/static/images/why-onsitego.svg")

  const onTabClick = (id:any) =>{
    router.push(`/${id}`)
  }
  React.useEffect(()=>{
    trackPage("Privacy Policy",{...getPageViewData()})
},[])

  return (
    <Fragment>
      <Head>
        <title>Privacy Policy | Onsitego</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content="We are committed to protecting our customers' privacy and personal data. We use the information provided by you to process requests."></meta>
        <meta property="og:title" content="Privacy Policy | Onsitego"/>
        <meta property="og:description" content="We are committed to protecting our customers' privacy and personal data. We use the information provided by you to process requests."/>
        <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
        <meta property="og:image" content={OG_IMAGE}/>
        <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
      </Head>
      <PlainBanner title="Privacy Policy - Onsitego" />
      <PrivacyPolicy />
    </Fragment>
  )
}